/**
 * Created by PuTi(编程即菩提) 3/16/17.
 * application
 */
var nb = require('../../core/js/nb');
var Page = require('./view/Page');
var Model = require('./Model');

var opts = nb.opts;
var window = opts.window;
var $ = opts.$;
var document = opts.document;
var debug = process.env.APP_DEBUG == true;

/**
 * get url query
 * @returns {{}}
 */
function getQuery() {
    var params = decodeURIComponent(location.search);
    var query = {};
    if (params.indexOf("?") != -1) {
        params = params.substr(1).split("&");
        for (var i = 0; i < params.length; i++) {
            var param = params[i].split('=');
            query[param[0]] = param[1];
        }
    }
    return query;
}
var getCookie = function () {
    var result = {};
    var cookie = document.cookie;
    var list = cookie.split(';');
    $.each(list,function(inIndex,inValue){
        var parts = cookie.split('=');
        if(parts.length === 2){
            result[parts.shift().trim()] = decodeURI(parts.join('='));
        }
    });
    return result;
};

function fetchInitData() {
    var initData = window[opts.appInitData];
    if (initData) {
        opts.mixRender = true
    }
    return initData;
}

function start(inPageType, inModelType, inGetPageData,inConfigData) {
    var initData = fetchInitData();
    var page = new inPageType();
    var model = new inModelType();
    var dom;
    if (debug) {
        window.__appModel = model;
        window.__appPage = page;
    }
    if (initData) {
        model.setAppData(initData);
        opts.mixRender = false;
    } else {
        if (inGetPageData) {
            // console.log(getQuery());
            inGetPageData({
                data: {
                    query:getQuery(),
                    cookie:getCookie()
                },
                scope: this,
                success: function (inData) {
                    model.setAppData(inData);
                }
            });
        }
        dom = page.$(true);
        $(document.body).append(dom);
    }
    if(inConfigData){
        model.set('config',inConfigData);
    }
    page.setModel(model);
    nb.model.set(opts.clientReady);
}

module.exports = {
    start: start,
    Model: Model,
    Page: Page,
    config: function (inConfig) {
        this.config = config = inConfig;
    }
};


//////////////////
// WEBPACK FOOTER
// /Users/Shared/Previously Relocated Items/Security/workspace/nb2-webpack3/server/nb/app/js/app.js
// module id = 34
// module chunks = 42